import { all, call, put, takeLatest } from 'redux-saga/effects';
import { AnyAction } from 'redux';

import * as constants from 'redux/constants/deaths.constants';
import { getAll, getForm, getOne, save, softDelete } from 'services/deaths.services';

export function* deathsDelete(action: AnyAction): Generator {
  try {
    const { id } = action;
    const { data }: any = yield call(softDelete, id);
    yield put({
      type: constants.DEATHS_ON_DELETE_SUCCEEDED,
      data: { ...data, id },
    });
  } catch (error) {
    yield put({ type: constants.DEATHS_ON_DELETE_FAILED, error });
  }
}

export function* deathsGetAll(action: AnyAction): Generator {
  try {
    const { limit, page, search, sortKey, sortType } = action;
    const { data }: any = yield call(getAll, limit, page, search, sortKey, sortType);
    yield put({
      type: constants.DEATHS_ON_GET_ALL_SUCCEEDED,
      data,
    });
  } catch (error) {
    yield put({ type: constants.DEATHS_ON_GET_ALL_FAILED, error });
  }
}

export function* deathsGetForm(): Generator {
  try {
    const { data }: any = yield call(getForm);
    yield put({ type: constants.DEATHS_ON_GET_FORM_SUCCEEDED, data });
  } catch (error) {
    yield put({ type: constants.DEATHS_ON_GET_FORM_FAILED, error });
  }
}

export function* deathsGetOne(action: AnyAction): Generator {
  try {
    const { id } = action;
    if (id) {
      const { data }: any = yield call(getOne, id);
      yield put({ type: constants.DEATHS_ON_GET_ONE_SUCCEEDED, data });
    }
  } catch (error) {
    yield put({ type: constants.DEATHS_ON_GET_ONE_FAILED, error });
  }
}

export function* deathsSave(action: AnyAction): Generator {
  try {
    const { formData, id } = action;
    const { data }: any = yield call(save, formData, id);
    yield put({ type: constants.DEATHS_ON_SAVE_SUCCEEDED, data });
  } catch (error) {
    yield put({ type: constants.DEATHS_ON_SAVE_FAILED, error });
  }
}

export function* watchDeaths(): Generator {
  yield all([
    takeLatest(constants.DEATHS_ON_DELETE_REQUESTED, deathsDelete),
    takeLatest(constants.DEATHS_ON_GET_ALL_REQUESTED, deathsGetAll),
    takeLatest(constants.DEATHS_ON_GET_FORM_REQUESTED, deathsGetForm),
    takeLatest(constants.DEATHS_ON_GET_ONE_REQUESTED, deathsGetOne),
    takeLatest(constants.DEATHS_ON_SAVE_REQUESTED, deathsSave),
  ]);
}
